import type { Band } from "./types";

export const fetchBands = async (): Promise<Band[]> => {
  try {
    const res = await fetch("/data/bands.json", { cache: "no-cache" });
    return await res.json();
  } catch (err) {
    console.error("Impossible de charger bands.json", err);
    return [];
  }
};